export { ProductDetailTemplate } from './ProductDetailTemplate';
export type { ProductDetailTemplateProps } from './ProductDetailTemplate.types';
